/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportFlowContainer_viewer = {
    readonly id: string;
    readonly " $refType": "ReportFlowContainer_viewer";
};
export type ReportFlowContainer_viewer$data = ReportFlowContainer_viewer;
export type ReportFlowContainer_viewer$key = {
    readonly " $data"?: ReportFlowContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportFlowContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportFlowContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '0da369176b07bf64bdcebf6ceb095ddc';
export default node;
